<template>
  <el-container class="mall-app-container">
    <el-header class="mall-header">
      <div class="header-inner">
        <!-- Logo 区域 -->
        <div class="brand-logo" @click="$router.push('/mall')">
          <img src="@/assets/img/logo.png" alt="logo" class="logo-img">
          <span class="logo-text">宝淘秒杀</span>
        </div>

        <!-- 导航菜单 -->
        <div class="header-nav">
          <el-menu
            :default-active="$route.path"
            router
            mode="horizontal"
            class="custom-menu"
          >
            <el-submenu index="/mall/my" popup-class="menu-popup">
              <template slot="title">
                <i class="el-icon-user-solid" />
                <span>配置管理</span>
              </template>
              <el-menu-item index="/mall/seckill">
                <i class="el-icon-setting" />
                <span>秒杀活动配置</span>
              </el-menu-item>
              <el-menu-item index="/mall/order">
                <i class="el-icon-s-order" />
                <span>我的订单</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="/mall/cart">
              <template slot="title">
                <i class="el-icon-shopping-cart-2" />
                <span>购物车</span>
                <el-badge v-if="cartCount > 0" class="cart-badge" :value="cartCount" :max="99" />
              </template>
            </el-menu-item>

            <el-menu-item index="/mall/fav">
              <template slot="title">
                <i class="el-icon-star-on" />
                <span>收藏夹</span>
              </template>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 用户信息与下拉 -->
        <div class="user-profile">
          <el-dropdown trigger="click" placement="bottom-end">
            <div class="avatar-wrapper">
              <img :src="user.avatarUrl || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" class="user-avatar" alt="avatar">
              <i class="el-icon-caret-bottom avatar-arrow" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item icon="el-icon-s-platform" @click.native="goToHome">回到主站</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" class="logout-item" @click.native="goToLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>

    <el-container class="main-container">
      <el-main class="mall-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { userMixin } from 'assets/js/mixin'

export default {
  name: 'Mall',
  mixins: [userMixin],
  data() {
    return {
      user: {
        avatarUrl: ''
      },
      cartCount: 0
    }
  },
  created() {
    document.title = '宝淘秒杀商城'
    this.user = this.$store.state.userInfo || {}
  }
}
</script>

<style scoped>
.mall-app-container {
  min-height: 100vh;
  background-color: #f6f8fa;
}

.mall-header {
  background: #1f2429;
  height: 64px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0;
}

.header-inner {
  max-width: 1240px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.logo-img {
  width: 34px;
  height: 34px;
  border-radius: 8px;
}

.logo-text {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #fff 0%, #ff6b6b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-nav {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-right: 24px;
}

.custom-menu {
  background: transparent !important;
  border-bottom: none !important;
}

.custom-menu ::v-deep .el-menu-item,
.custom-menu ::v-deep .el-submenu__title {
  color: #c0c4cc !important;
  height: 64px !important;
  line-height: 64px !important;
  border-bottom: 2px solid transparent !important;
  font-size: 14px;
  padding: 0 16px !important;
}

.custom-menu ::v-deep .el-menu-item:hover,
.custom-menu ::v-deep .el-submenu__title:hover {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.custom-menu ::v-deep .el-menu-item.is-active,
.custom-menu ::v-deep .el-submenu.is-active .el-submenu__title {
  color: #ff4d4f !important;
  border-bottom-color: #ff4d4f !important;
  font-weight: 600;
}

.cart-badge {
  margin-left: 6px;
}

.cart-badge ::v-deep .el-badge__content {
  background-color: #ff4d4f;
  border: none;
  font-weight: bold;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 20px;
  transition: background 0.2s ease;
}

.avatar-wrapper:hover {
  background: rgba(255, 255, 255, 0.08);
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #ff4d4f;
  object-fit: cover;
}

.avatar-arrow {
  color: #909399;
  font-size: 12px;
}

.main-container {
  padding-top: 10px;
}

.mall-main {
  padding: 0;
}
</style>
